"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.bulkUpload.files.successProcessing': 'Sus {count} archivo(s) serán procesados en segundo plano y añadidos a su base de conocimientos.',
    'knowledge.bulkUpload.files.partialSuccess': '{successCount} archivo(s) serán procesados en segundo plano, {errorCount} fallaron.',
    'knowledge.bulkUpload.files.allFailed': 'Error al subir todos los {count} archivo(s).',
    'knowledge.bulkUpload.googleDrive.successProcessing': 'El directorio de Google Drive "{directoryName}" será procesado en segundo plano y añadido a su base de conocimientos.',
};
